<script setup>
import { safeParsePostMessage } from '@/utils/postMessageHelpers';
import { onMounted, ref } from 'vue';

const CHATBOT_URL = import.meta.env.VITE_CHATBOT_URL;

const emit = defineEmits(['onSidebarClosed']);

const isOpen = ref(false);

function open() {
  isOpen.value = true;
}

function close() {
  isOpen.value = false;
}

function isOpened() {
  return isOpen.value;
}

onMounted(() => {
  window.addEventListener('message', handleMessage);
});

const handleMessage = async (e) => {
  const msg = safeParsePostMessage(e.data);
  if (msg.MessageId === "Close_AI_Chatbot") {
    emit('onSidebarClosed');
  }
}

defineExpose({
  open, close, isOpened
});
</script>

<template>
  <div v-show="isOpen" id="chatSidebar">
    <iframe :src="CHATBOT_URL" class="react-iframe" frameborder="0" allowfullscreen></iframe>
  </div>
</template>

<style>
 #chatSidebar {
   height: 100%;
 }

 #chatSidebar > iframe {
   height: 100%;
   width: 100%;
 }
</style>
